import { useEffect, useRef, useState } from 'react';
import DevelopProjectsEdit from './DevelopProjectsEdit';
import WebUniversal, { WUExtendPropsType } from '../system/WebUniversalNewEx'
import { columnsheadId } from '../universal/columnshead';

/**
 * 组件 DevelopProjects 
 * @param props 
 * @returns 
 */
const DevelopProjects = (props: any) => {
    const apiId = 'developProjects';

    //刷新变量
    const [refresh, setRefresh] = useState(0);
    /** 可使用WebUniversal(父)组件函数 */
    const ref = useRef<any>(undefined);
    /** 刷新数据 */
    let initData: any;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            initData = ref.current.initData;
        }
        // const fetchData = async () => {
        // };
        // fetchData();
        if (refresh !== 0) {
            initData();
        }
    }, [refresh]); //初始化数据

    /** 表头内容 */
    const columnsHead = [
        {
            title: '项目',
            dataIndex: 'projectName',
        },
        {
            title: '服务地址',
            dataIndex: 'serviceUrl',
        },
        {
            title: '备注',
            dataIndex: 'memo',
        }
    ];

    /**
     * 表头
     */
    const columns = columnsheadId
        .concat(columnsHead as []);

    /**
     * 扩展Props
     */
    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '项目',
        apiId,
        columns,
        showStates: true,
        EditComponent: DevelopProjectsEdit
    };

    return (
        <>
            <WebUniversal props={extendProps} ref={ref} />
        </>
    )
}

export default DevelopProjects;